<!-- eslint-disable vue/no-parsing-error -->
<!-- eslint-disable vue/valid-v-for -->
<template>
  <div
    v-if="files.length"
    class="mt-2 mb-1 mx-2"
  >
    <div class="d-flex justify-content-start align-items-center">
      <base-text
        semibold
        class="mr-3"
        size="m"
      >
        Attachments:
      </base-text>
      <div class="files">
        <!-- before, "file, index in files" -->
        <div
          v-for="file, index in files"
          :key="`file_item_${index}`"
          class="files__item"
        >
          <div
            class="files__item__filename"
            :class="`${file.progress ? '' : 'ready'}`"
          >
            <span>
              {{ file.name }}
            </span>
            <base-icon
              v-if="!file.progress"
              icon="remove-attachment"
              class="button"
              @click="$emit('clear')"
            />
          </div>
          <base-progress-bar
            v-if="file.progress"
            class="files__item__progress"
            :class="`ml-3`"
            :current="file.progress"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Attachments',
  props: {
    files: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    fakeFiles() {
      return [...Array(10).keys()]
        .map((x) => this.files[x % this.files.length])
        .map((file, index) => ({
          ...file,
          // Random length, 1 to 6 times
          name: 'Just testing '.repeat(Math.round(Math.random() * 6 + 1)),
          // Random progress, 50% chance no progress, 50% chance random from 0 to 100
          progress: (Math.random() < 0.5 ? Math.random() * 100 : null),
        }));
    },
  },
};
</script>
<style lang="scss"
  scoped>
::v-deep .base-progress-bar {
  width: 214px;
  height: 9px;
  background-color: transparent;
  border: #aaa 1px solid;
  border-radius: 5px;
  position: relative;
  overflow: hidden;

  &__bar {
    position: absolute;
    height: 100%;
    background-color: #F2CEB1;
    margin: 0;
  }
}

.files {
  display: grid;

  &__item {
    display: inline-flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    overflow: hidden;

    &__filename {
      text-overflow: ellipsis;
      overflow: hidden;
      font-family: $font-family-sans-serif;
      position: relative;
      .button {
        position: absolute;
        right: 5px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    &__progress {
      flex-shrink: 0;
    }
  }
}

.ready {
  border: 1px solid #aaa;
  border-radius: 5px;
  padding: 2px 13px;
  padding-right: 30px;
}
</style>
